import { getClosedAutocomplete } from "./api";
import { replaceWordList, ignoreWordList } from "./data/replaceWordList";

/**
 * バックエンドに投げるAutoompleteの文字列に補正をかける
 * @param input 入力文字列
 * @returns APIに投げる文字列
 */
export const replaceInput = (input: string) => {
  const replceInput = replaceWordList.map((word)=>{
    if(input === word.base) {
      return word.replace;
    }
    return null;
  })
  .find((x)=>{
    return x !== null;
  });
  if(replceInput) {
    return replceInput;
  }
  return input;
}

/**
 * バックエンドに投げる文字列に補正をかけた状態でAutocompleteにリクエストを投げる
 * @param input 入力文字列
 * @returns バックエンドからのResponse
 */
export const getClosedFixAutocomplete = async (input: string, lang: string = 'ja') => {
  const replaced = replaceInput(input);
  // 無視リストにある場合にはインクリメンタルサーチを行わない
  if(ignoreWordList.includes(input)) {
    return null;
  }
  return await getClosedAutocomplete(replaced, lang)
}
